import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { ApiService } from '@/services/api/ApiService';
import type { GetActivitiesApiParams, GetActivitiesResponse } from '@/types/activity';

const ITEMS_PER_PAGE = 20;

export const useActivities = (
  filters: Omit<GetActivitiesApiParams, 'limit' | 'offset'>,
  options?: { enabled?: boolean },
) => {
  return useInfiniteQuery<GetActivitiesResponse>({
    queryKey: ['activities', filters],
    queryFn: ({ pageParam = 0 }) =>
      ApiService.invoke({
        resource: 'activities',
        action: 'all',
        data: { ...filters, limit: ITEMS_PER_PAGE, offset: pageParam as number },
      }),
    getNextPageParam: (lastPage) => {
      const nextOffset = lastPage.offset + lastPage.limit;
      return nextOffset < lastPage.count ? nextOffset : undefined;
    },
    initialPageParam: 0,
    staleTime: 2 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
};

export const useRecentActivities = (limit: number = 20) => {
  return useQuery<GetActivitiesResponse>({
    queryKey: ['activities', 'recent', limit],
    queryFn: () =>
      ApiService.invoke({
        resource: 'activities',
        action: 'all',
        data: { limit, offset: 0 },
      }),
    staleTime: 60 * 1000,
  });
};
